<template>
  <div class="vehicle-tracking-main">
    <div class="main-container" :style="mainContainerStyling" ref="main-cont">
      <!-- #region Top Horizontal Section -->
      <div class="top-section" :style="topSectionStyling">
        <div class="menu-section">
          <Menus :menu="topMenus" ref="topMenu" @menuClicked="topMenuClicked" />
        </div>
        <div class="section-content">
          <div class="content" :style="mapStyling">
            <CustomMap :mapObject.sync="myMap" :markers="mapMarker" ref="vehicleMap" @markerClicked="markerClicked" viewMode hideSlot />
            <div class="additional-content">
              <div v-if="showLegend" class="content-items">
                <div class="legend-item">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/TruckOn.png" />
                  <div>In Del/Col</div>
                </div>
                <div class="legend-item">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/TruckOff.png" />
                  <div>No Job</div>
                </div>
                <div class="legend-item">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/Warehouse.png" />
                  <div>RFC Container</div>
                </div>
              </div>
              <div v-if="showInterval" class="content-items">
                <div>Refresh every:</div>
                <button @click="intervalClicked(10 * 1000)">{{ currentInterval == 10 * 1000 ? '✔️' : '' }} 10 seconds</button>
                <button @click="intervalClicked(30 * 1000)">{{ currentInterval == 30 * 1000 ? '✔️' : '' }} 30 seconds</button>
                <button @click="intervalClicked(5 * 60 * 1000)">{{ currentInterval == 5 * 60 * 1000 ? '✔️' : '' }} 5 minutes</button>
                <button @click="intervalClicked(10 * 60 * 1000)">{{ currentInterval == 10 * 60 * 1000 ? '✔️' : '' }} 10 minutes</button>
                <button @click="intervalClicked(30 * 60 * 1000)">{{ currentInterval == 30 * 60 * 1000 ? '✔️' : '' }} 30 minutes</button>
                <button @click="intervalClicked(60 * 60 * 1000)">{{ currentInterval == 60 * 60 * 1000 ? '✔️' : '' }} 1 hour</button>
              </div>
            </div>
          </div>
          
          <!-- #region Vertical Resizer -->
          <!-- <div class="resizer hresizer" :style="resizerStyling" @mousedown="horizontalResizerMousedown"></div> -->
          <div class="resizer vresizer" :style="mapResizerStyling" @mousedown="verticalResizerMousedown"></div>
          <!-- <div class="resize-bar vresize-bar" :style="resizeBarStyling"></div> -->
          <div class="resize-bar vresize-bar" :style="mapResizeBarStyling"></div>
          <!-- #endregion -->

          <div class="content" style="position: relative;">
            <TableBox class="table-section" title="Vehicle List" :tableData="vehicleList" :additionalButtons="vehicleListButtons" :loading="vehicleLoading"
              :maxSelection="0" @buttonClicked="vehicleButtonClicked" :hideColumns="[ 'fullData', 'Position', 'Staff_Status', 'DepartureCompanyCode', 'DestinationCompanyCode']" :stickColumn="[0]" :rowHeight="50"/>
            <!-- <Tooltip style="position: absolute; top: 0; right: 5px; zIndex:25" position="left" tooltipText="Please refresh if the table's alignment is not in a proper coordination. We are working on fixing the bug. Thank you." :width="450"/> -->
          </div>
        </div>
      </div>
      <!-- #endregion -->
      
      <!-- #region Horizontal Resizer -->
      <div class="resizer hresizer" :style="resizerStyling" @mousedown="horizontalResizerMousedown"></div>
      <div class="resize-bar hresize-bar" :style="resizeBarStyling"></div>
      <!-- #endregion -->
      
      <!-- #region Bottom Horizontal Section -->
      <div class="bottom-section">
        <div class="menu-section">
          <Menus :menu="bottomMenus" @menuClicked="bottomMenuClicked" />
        </div>
        <div class="job-listing-section">
          <div v-for="(m, i) in bottomMenus" :key="i" :style="{ display: m['show'] ? '' : 'none' }">
            <TableBox :title="`${m['title']} List`" :tableData="m['tableData']" :additionalButtons="bottomTableButtons" @buttonClicked="bottomTableButtonClicked(...arguments, m['title'])"
              :maxSelection="0" :stickColumn="[0]" :rowHeight="50"/>
            <div v-if="m['loading']" class="loader">
              <div class="content">Loading {{ m['title'] }} List</div>
            </div>
          </div>
          <div class="empty" v-if="bottomMenus.filter(m => m['show']).length == 0">
            <div class="empty-content">
              Select a job listing to preview
            </div>
          </div>
        </div>
      </div>
      <!-- #endregion -->
    </div>


      <!-- high zindex to be placed above fullscreen map -->
    <RightMenu style="zIndex:9999999999" :showMenu.sync="rightMenuShow" :width.sync="rightMenuWidth" overlay :showCloseButton="false" :maxWidth="550" :minWidth="435" :defaultWidth="435">
      <AssignV3 v-if="assignShow && !pendingTripShow && !statusTaskUpdateShow" :show.sync="assignShow" :assignData="assignSelected" :subShow.sync="rightMenuShow" @tripAssigned="tripAssigned"/>
      <div v-if="pendingTripShow && !assignShow && !statusTaskUpdateShow" class="pending-trip-main">
        <div class="pending-trip-header" :style="pendingTripHeaderFooterStyling">
          <span>Pending Trips</span>
          <img @click="rightMenuCloseClicked" style="width: 18px; height: 18px; cursor: pointer;"  src="https://dsmlib.logistics.systems/Icons/Cancel.png">
          <!-- <button @click="pendingTripShow = false; rightMenuShow = false; selectedPendingTrip = []; assignShow = false; assignSelected = null;">Close</button> -->
        </div>
        <div class="pending-trip-content">
          <div class="label-container">
            <div class="label-row">
              <div class="label-title">
                Vehicle
              </div>
              <div class="label-value">
                {{(selectedPendingTrip.length == 0) ? '' : (selectedPendingTrip[0]['Vehicle']) }}
              </div>
            </div>

            <div class="label-row">
              <div class="label-title">
                Driver
              </div>
              <div class="label-value">
                <div v-html="(selectedPendingTrip.length == 0) ? '' : (selectedPendingTrip[0]['Driver'])"></div>
              </div>
            </div>
          </div>
          <div style="display:flex; width: 100%; justify-content:center; align-items:center;" v-if="selectedPendingTrip.length == 0">
            <p>No Data</p>
          </div>
          <div class="content-container" v-else>
            <div
              class="white-container"
              v-show="!consignmentDetailShow"
              v-for="(data, index) in selectedPendingTrip"
              :key="index"
              @click="whiteContainerClicked($event, index, data['FullData'])"
              :style="{
                backgroundColor : (index == selectedIndex) ? 'rgb(120, 120, 255)' : '', color : (index === selectedIndex) ? 'white' : ''
              }"
            >
              <div class="white-container-left">
                <div class="pt-row">
                  <div class="pt-title">{{(data['Container #'] == '') ? '-' : data['Container #']}}</div>
                  <div class="pt-value">{{(data['SzTy'] == '') ? '-' : data['SzTy']}}</div>
                </div>
                <div class="pt-row" :style="{display : (!data['B2BContainer #']) ? 'none' : ''}">
                  <div class="pt-title">{{(data['B2BContainer #'] == '') ? '-' : data['B2BContainer #']}}</div>
                  <div class="pt-value">{{(data['B2BSzTy'] == '') ? '-' : data['B2BSzTy']}}</div>
                </div>
                <div class="pt-row">
                  <div class="pt-title">{{(data['Consignment #'] == '') ? '-' : data['Consignment #']}}</div>
                  <div class="pt-value">{{(data['MovementType'] == '') ? '-' : data['MovementType']}}</div>
                </div>
                <div class="pt-row">
                  <div class="pt-title">{{(data['BillToName'] == '') ? '-' : data['BillToName']}}</div>
                  <div class="pt-value">{{(data['FromToArea'] == '') ? '-' : data['FromToArea']}}</div>
                </div>
              </div>

              <div class="white-container-right">
                <Tooltip v-if="!data['FullData'] ? false : (data['FullData']['PickupIn'] || data['FullData']['PickupOut'] || data['FullData']['DropoffIn'] || data['FullData']['DropoffOut'])" :showIndicator="false" :iconSize="18" position="left" :minWidth="200">
                  <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/TruckOn.png"/>
                  <div slot="tooltipText">
                    <span>Next Action : {{( !data['FullData'] ? '-' : data['FullData']['DropoffIn'] ? 'Drop Off Out' : (data['FullData']['PickupOut'] ? 'Drop Off In' : (data['FullData']['PickupIn'] ? 'Pick Up Out' : 'Pick Up In'))) }}</span>
                  </div>
                </Tooltip>
                <div class="white-container-right-lower">
                  <Tooltip v-if="data['FullData'] && data['FullData']['cmbook']" :showIndicator="false" :iconSize="18" position="left" :minWidth="250">
                    <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/icon8-booking.png"/>
                    <div slot="tooltipText">
                      <span>Port/Depot Bkg : {{ `${!data['FullData']  ? '-' : !data['FullData']['cmbookid']? '-' : data['FullData']['cmbookid']} by ${!data['FullData']  ? '-' : !data['FullData']['cmbookuser']? '-' : data['FullData']['cmbookuser']}` }}</span>
                      <br>
                      <span>Bkg Remarks : {{ !data['FullData']  ? '-' : !data['FullData']['cmbookremarks']? '-' : data['FullData']['cmbookremarks'] }}</span>
                    </div>
                  </Tooltip>
                  <Tooltip style="cursor: pointer;" @click.native="consignmentInfoClicked($event, data['FullData'])" :iconSize="18" position="left" :minWidth="150" tooltipText="Consignment Details"/>
                </div>
              </div>
            </div>
            <div v-show="consignmentDetailShow" class="consignment-details">
              <div class="consignment-detail-close">
                <button @click="consignmentDetailShow = false;">Close</button>
                <!-- // <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" @click="consignmentDetailShow = false;"/> -->
              </div>
              <div class="tab-row">
                <span>Trip #</span>
                <span>{{!receivedData ? '-' : !receivedData['JINo'] ? '-' : receivedData['JINo']}}</span>
                <span>{{!receivedData ? '-' : !receivedData['MovementType'] ? '-' : receivedData['MovementType']}}</span>
              </div>
              <div class="tab-row">
                <span>Cust</span>
                <span>{{!receivedData ? '-' : !receivedData['BillToName'] ? '-' : receivedData['BillToName']}}</span>
              </div>
              <div class="tab-row">
                <span>Cont #</span>
                <span>{{!receivedData ? '-' : !receivedData['ContainerNo'] ? '-' : receivedData['ContainerNo']}}</span>
                <span>{{contSzTyp}}</span>
              </div>
              <div class="tab-row">
                <span>B2B</span>
                <span>{{!receivedData ? '-' : !receivedData['B2BContainerNo'] ? '-' : receivedData['B2BContainerNo']}}</span>
              </div>
              <div class="tab-row">
                <span>B2B CN</span>
                <span>{{!receivedData ? '-' : !receivedData['B2BConsignmentNo'] ? '-' : receivedData['B2BConsignmentNo']}}</span>
              </div>
              <div class="tab-row">
                <span>Bkg Ref</span>
                <span>{{!receivedData ? '-' : !receivedData['BookingRefNo'] ? '-' : receivedData['BookingRefNo']}}</span>
                <span>{{!receivedData ? '-' : !receivedData['ShipCall_No'] ? '-' : receivedData['ShipCall_No']}}</span>
              </div>
              <div class="tab-row">
                <span>From</span>
                <span>{{!receivedData ? '-' : !receivedData['FromDestCode'] ? '-' : receivedData['FromDestCode']}}</span>
                <span>{{!receivedData ? '-' : !receivedData['FromArea'] ? '-' : receivedData['FromArea']}}</span>
              </div>
              <div class="tab-row">
                <span>Tel #</span>
                <span>{{!receivedData ? '-' : !receivedData['FromTelNo1'] ? '-' : receivedData['FromTelNo1']}}</span>
                <span>{{!receivedData ? '-' : !receivedData['FromTelNo2'] ? '-' : receivedData['FromTelNo2']}}</span>
              </div>
              <div class="tab-row">
                <span>Address</span>
                <span v-html="addressFrom"></span>
              </div>
              <div class="tab-row">
                <span>To</span>
                <span>{{!receivedData ? '-' : !receivedData['ToDestCode'] ? '-' : receivedData['ToDestCode']}}</span>
                <span>{{!receivedData ? '-' : !receivedData['ToArea'] ? '-' : receivedData['ToArea']}}</span>
              </div>
              <div class="tab-row">
                <span>Tel #</span>
                <span>{{!receivedData ? '-' : !receivedData['ToTelNo1'] ? '-' : receivedData['ToTelNo1']}}</span>
                <span>{{!receivedData ? '-' : !receivedData['ToTelNo2'] ? '-' : receivedData['ToTelNo2']}}</span>
              </div>
              <div class="tab-row">
                <span>Address</span>
                <span v-html="addressTo"></span>
              </div>
              <div class="tab-row">
                <span>B2B To</span>
                <span>{{!receivedData ? '-' : !receivedData['B2BToDestCode'] ? '-' : receivedData['B2BToDestCode']}}</span>
              </div>
              <div class="tab-row">
                <span>Operator</span>
                <span>{{!receivedData ? '-' : !receivedData['Operator'] ? '-' : receivedData['Operator']}}</span>
              </div>
              <div class="tab-row">
                <span>Port/Depot Bkg</span>
                <span>{{portDepotBookingText}}</span>
              </div>
              <div class="tab-row">
                <span>Bkg Remarks</span>
                <span>{{!receivedData ? '-' : !receivedData['cmbookremarks'] ? '-' : receivedData['cmbookremarks']}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pending-trip-footer" :style="pendingTripHeaderFooterStyling">
          <button class="pending-trip-footer-button" :disabled="pendingTripFooterButtonDisable" @click="editTripButtonClicked">
            Edit Trip
          </button>
          <button class="pending-trip-footer-button" :disabled="pendingTripFooterButtonDisable" @click="deleteTripButtonClicked">
            Delete Trip
          </button>
          <button class="pending-trip-footer-button" :disabled="pendingTripFooterButtonDisable" @click="radioCallButtonClicked">
            {{ radioCallButtonLabel }}
          </button>
        </div>
      </div>

      <div v-if="statusTaskUpdateShow && !assignShow && !pendingTripShow" class="status-task-update-main">
        <div class="status-task-update-header" :style="pendingTripHeaderFooterStyling">
          <div @click="statusTaskBackClicked">ᐊ</div>
          <span>{{ !selectedWhiteContainer ? '-' : `${selectedWhiteContainer['PMCode']} (${selectedWhiteContainer['PMNo']}) - ${selectedWhiteContainer['Driver']} ${selectedWhiteContainer['DriverName']}` }}</span>
          <img @click="rightMenuCloseClicked" src="https://dsmlib.logistics.systems/Icons/Cancel.png">
        </div>
        <div class="status-task-update-body" >
          <HMSUpdateStatusTask :data="selectedWhiteContainer" :rightMenuWidth="rightMenuWidth" :attachmentsChanged.sync="radioCallAttachmentsChanged" @statusUpdate="radioCallStatusUpdated" @statusReverse="radioCallStatusReversed"/>
        </div>
        <div class="status-task-update-footer" :style="pendingTripHeaderFooterStyling">
          <div class="message-container" v-html="radioCallResultMessage" :style="messageContainerStyling" style="font-weight: bold;"></div>
        </div>
      </div>
    </RightMenu>


    <!-- Google Map RFC Container's Info Window -->
		<div class="mainDiv" style="display: none;">
			<div class="infoMain">
				<!-- <div class="infoRow">
					<div class="infoTitle">{{ dataToPreview[dataToPreviewIndex] ? dataToPreview[dataToPreviewIndex]['JobNo'] : '' }}</div>
					<div class="infoValue">{{ dataToPreview[dataToPreviewIndex] ? dataToPreview[dataToPreviewIndex]['CNContNo'] : '' }}</div>
				</div> -->
				<div class="infoRow" v-for="(data, index) in infoWindowArr" :key="index">
					<div class="infoTitle" v-html="data['title']"></div>
					<div class="infoValue" v-html="data['value']"></div>
				</div>
				<div class="button-container">
					<div class="button-left-container">
						<button onclick="assignCollection()">Assign Collection</button>
					</div>
					<div class="button-right-container">
						<img onclick="previousPage()" src="https://img.icons8.com/material-rounded/96/000000/double-left.png" alt="">
						<div class="counter">{{ dataToPreviewIndex + 1 }} of {{ dataToPreview.length }}</div>
						<img onclick="nextPage()" src="https://img.icons8.com/material-rounded/96/000000/double-right.png" alt="">
					</div>
				</div>
			</div>
		</div>

    <PopupV2
      class="delete-trip-popup"
      :show="showDeleteTripPopup"
      type="warning"
      title="Delete Trip"
      :buttons="deleteTripPopupButtons"
      @buttonClicked="deleteTripPopupButtonClicked"
    >
      <div class="prompt">
        <span>Are you sure you want to delete this trip?</span>
      </div>
      <table class="trip-details">
        <tr>
          <td class="detail-name">Driver</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? `${selectedWhiteContainer['DriverName']} (${selectedWhiteContainer['Driver']})` : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Prime Mover</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? `${selectedWhiteContainer['PMNo']} (${selectedWhiteContainer['PMCode']})` : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Consignment No.</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? selectedWhiteContainer['ConsignmentNo'] : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Container No.</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? selectedWhiteContainer['ContainerNo'] : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Movement Type</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? selectedWhiteContainer['MovementType'] : ''}}</td>
        </tr>
      </table>
      <Input
        class="reason"
        placeholder="Reason"
        :inputValue.sync="deleteTripPopupReasonInputValue"
        :isRequired="true"
        :errorMessage.sync="deleteTripPopupReasonInputErrorMessage"
      />
    </PopupV2>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {

      selectedDriver : null, // for refresh after status task update


      //#region Radio Call
      selectedIndex : -1,
      selectedWhiteContainer : null,
      showMoreActionsMenu: false,
      consignmentDetailShow : false,

      receivedData : null,
      statusTaskUpdateShow : false,
      radioCallAttachmentsChanged: false,
      radioCallResultMessage : '',
      radioCallUpdateSuccess : null,

      //#endregion

			infoWindowArr : [],
      //#region Sizes
      horizontalResizing: false,
      topHeight: (window.innerHeight / 2) - 20,

      mapResizing: false,
      mapWidth: (window.innerWidth / 2) - 150,
      topMenuWidth: 0,
      //#endregion

      //#region Menus
      topMenus: [
        { title: 'Show RFC Containers', icon: 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RFC_gray.png', show: false },
        { title: 'Refresh', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png' },
        { title: 'Refresh Interval', icon: 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RefreshTimer.png' },
        { title: 'Legend', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Legend.png' },
      ],
      bottomMenus: [],
      openMenuTitles: [],
      //#endregion

      vehicleList: [],
      vehicleMarkers : [],
      refreshInterval: null,
      vehicleLoading: false,
      vehicleListButtons: [
        { text: '<img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-in-transit-64.png" height="15" width="15">', index: 0 },
        { text: '<img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-location-64.png" height="15" width="15">', index: 1 },
      ],

      bottomTableButtons: [
        { text: '<img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-in-transit-64.png" height="15" width="15">', index: 0 }
      ],
      assignShow: false,
      assignSelected : null,
      assignTitle : '',
      rightMenuWidth: 0,

      mapMarker: [],
      selectedMarker : null,
      myMap : null,
      showLegend: false,
      showInterval: false,
      currentInterval: 3600000,

      showRFCContainer : false,
      rfcContainersData : [],
      rfcMarkers : [],
      assignCollectionData: null,

      infoWindowOpened: null,

      rightMenuShow : false,
      pendingTripShow : false,
      selectedPendingTrip : [],
      pendingTripHeaderFooterBg : '',
			identicalLatLng : [],
			dataToPreview: [],
			dataToPreviewIndex: 0,

			markerCluster : null,

      showDeleteTripPopup: false,
      deleteTripPopupButtons: [
        { "text": "Delete", "color": "red", "textColor": "white" },
        { "text": "Cancel", "color": "lightgray" },
      ],
      deleteTripPopupReasonInputValue: "",
      deleteTripPopupReasonInputErrorMessage: "",
    }
  },
  computed: {
    topSectionStyling: function() {
      return {
        height: `${this.topHeight}px`,
        minHeight: `${this.topHeight}px`,
        maxHeight: `${this.topHeight}px`,
      }
    },
    resizerStyling: function() {
      return {
       
        top: this.horizontalResizing ? '' : `${this.topHeight}px`
      }
    },
    resizeBarStyling: function() {
      return {
        top: `${this.topHeight + 5}px`
      }
    },
    mapStyling: function() {
      return {
        width: `${this.mapWidth}px`,
        minWidth: `${this.mapWidth}px`,
        maxWidth: `${this.mapWidth}px`,
      }
    },
    mapResizerStyling: function() {
      return {
        left: this.mapResizing ? '' : `${this.mapWidth}px`
      }
    },
    mapResizeBarStyling: function() {
      return {
        left: `${this.mapWidth + 5}px`
      }
    },
    mainContainerStyling: function() {
      // this.mainContLength = this.$refs['main-cont'].getBoundingClientRect().width
      return {
        maxWidth : this.rightMenuShow ? `calc(100% - ${this.rightMenuWidth}px)` : `calc(100% - 5px)`
      
      }
    },
    totalMarkersOnMap : function () {
      return [...this.vehicleMarkers, ...this.rfcMarkers]
    },
    totalDataOnMap : function () {
      return [...this.vehicleList, ...this.rfcContainersData] 
    },
    pendingTripHeaderFooterStyling : function () {
      return {       
        backgroundColor : (this.pendingTripHeaderFooterBg === '') ? '#535cda' : (this.pendingTripHeaderFooterBg === true) ? '#26E07F' : '#FA314A'
      }
      
    },
    contSzTyp : function () {
      if (!this.receivedData) {
        return ''
      }
      return `${this.receivedData['ContSize']}${this.receivedData['ContType']}`
    },
    depDestCodeArea : function () {
      if (!this.receivedData) {
        return ''
      }
      return `${this.receivedData['FromDestCode']} (${this.receivedData['FromArea']}) - ${this.receivedData['ToDestCode']} (${this.receivedData['ToArea']})]`
    },
    addressFrom : function () {
      if (!this.receivedData) {
        return ''
      } else {
        return this.receivedData['FromAddress'].split('\r').join('<br>');
      }
    },
    addressTo : function () {
      if (!this.receivedData) {
        return ''
      } else {
        return this.receivedData['ToAddress'].split('\r').join('<br>');
      }
    },
    portDepotBookingText : function () {
      if (!this.receivedData) {
        return ''
      } else {
        return `${!this.receivedData['cmbookid'] ? '-' : this.receivedData['cmbookid']} by ${!this.receivedData['cmbookuser'] ? '-' : this.receivedData['cmbookuser']}`
      }
    },
    pendingTripFooterButtonDisable : function () {
      if (this.selectedIndex == -1) {
        return true;
      }
      return false;
    },
    radioCallButtonLabel: function() {
      if (this.selectedIndex == -1) {
        return '...';
      }

      if (this.selectedWhiteContainer['DropoffIn']) {
        return 'Drop Off Out';
      }

      if (this.selectedWhiteContainer['PickupOut']) {
        return 'Drop Off In';
      }

      if (this.selectedWhiteContainer['PickupIn']) {
        return 'Pick Up Out';
      }

      return 'Pick Up In';
    },
    messageContainerStyling : function() {
      return {
        backgroundColor : (this.radioCallUpdateSuccess === null) ? 'lightyellow' : (this.radioCallUpdateSuccess === true) ? 'lightgreen' : 'indianred',
        color : (this.radioCallUpdateSuccess === false ) ? 'white' : 'black'
      }
    }
  },
  props: {
  },
  methods: {
    radioCallDiscardAttachments: async function() {
      if (this.radioCallAttachmentsChanged) { // if there are newly uploaded attachments
        const response = await this.$showAlert( // prompt user to find out if they want to discard or not
          "warning",
          "Unsaved Attachments",
          "You have unsaved attachments.<br>Are you sure you want to discard them?",
          [
            { text: "Discard" },
            { text: "Cancel", color: "lightgray" },
          ]
        );

        return response == "Discard";
      }

      return true; // there are no newly uploaded attachments
    },
    statusTaskBackClicked : async function () {
      if (!(await this.radioCallDiscardAttachments())) {
        // if user does not want to discard newly uploaded attachments, don't go back to the trip list screen
        return;
      }

      this.radioCallTabShow = false;

      this.radioCallAttachmentsChanged = false;
      this.selectedWhiteContainer = null; 
      this.selectedIndex= -1;
      this.statusTaskUpdateShow = false;
      this.pendingTripShow = true; 
      this.radioCallResultMessage = ''; 
      this.radioCallUpdateSuccess = null;

      this.refreshPendingTrips();
    },
    radioCallStatusUpdated: function (e, result, title, hasSaved) {
      // scenario : 1 failed, 1 succeed will still counted as success
      this.radioCallUpdateSuccess = hasSaved;
      if (hasSaved) {
        this.radioCallResultMessage = `Successfully updated [${title}] status`;
      } else {
        this.radioCallResultMessage = result[0]['ErrMsg'] || result[1]['ErrMsg'];
      }
    },
    radioCallStatusReversed: function(results) { // results variable contains responses from API
      let success = [];
      let failure = "";
      for (const r of results) {
        if (r["Response"]["Results"] === 0) { // reversed successfully
          success.push(r["Reversed Status"]);
        } else { // reversed unsuccessfully (at most there will only be one, because it stops reversing after the first failure, and it should always be the first element in Results)
          failure = r["Reversed Status"];
        }
      }

      if (failure === "") { // no failures
        this.radioCallUpdateSuccess = true;
        this.radioCallResultMessage = `Successfully reversed ${success.join(", ")}`;
      } else { // 1 failure (at most only one, because it stops reversing after the first failure)
        this.radioCallUpdateSuccess = false;
        if (success.length == 0) { // no successes
          this.radioCallResultMessage = `Failed to reverse ${failure}`;
        } else {
          this.radioCallResultMessage = (
            "Failed to reverse some statuses<br/>" +
            `Success: ${success.join(", ")}<br/>` +
            `Failure: ${failure}`
          );
        }
      }
    },
    editTripButtonClicked: async function() {
      if (this.selectedIndex == -1) { // the button should be disabled if no trip is selected, but i'm handling it just in case
        this.$showAlert("error", "No Trip Selected", "Select a trip to edit", [{"text": "OK"}]);
        return;
      }

      this.$fullscreenLoading(`Getting ${this.selectedWhiteContainer["ConsignmentNo"]} Trip Details (${this.selectedWhiteContainer["MovementType"]})`);
      const response = await this.$apiCallV2(
        `/VehicleTracker/GetHMSTripDetails?consignmentno=${this.selectedWhiteContainer["ConsignmentNo"]}` +
        `&journeyguid=${this.selectedWhiteContainer["JourneyGUID"]}`
      );
      this.$fullscreenLoading();

      this.assignSelected = response[0];
      this.pendingTripShow = false;
      this.assignShow = true;
    },
    deleteTripButtonClicked: function() {
      if (this.selectedIndex == -1) { // the button should be disabled if no trip is selected, but i'm handling it just in case
        this.$showAlert("error", "No Trip Selected", "Select a trip to delete", [{"text": "OK"}]);
        return;
      }

      // only shows pending trips, no need to handle for historical trips unlike the Vehicle Schedule page

      this.deleteTripPopupReasonInputValue = "";
      this.deleteTripPopupReasonInputErrorMessage = "";
      this.showDeleteTripPopup = true;
    },
    deleteTripPopupButtonClicked: async function(buttonText) {
      if (buttonText === "Cancel") {
        this.showDeleteTripPopup = false;
        return;
      }

      if (this.deleteTripPopupReasonInputValue.trim() === "") {
        this.deleteTripPopupReasonInputErrorMessage = "Please enter your reason";
        return;
      }

      this.$fullscreenLoading(`Deleting ${this.selectedWhiteContainer["ConsignmentNo"]} trip (${this.selectedWhiteContainer["MovementType"]})`);

      const deleteTripResponse = await this.$apiCallV2("/VehicleSchedule/HMSUpdateTrip", {
        "action": "D",
        "cn": this.selectedWhiteContainer["ConsignmentNo"],
        "journeyguid": this.selectedWhiteContainer["JourneyGUID"],
        "delreason": this.deleteTripPopupReasonInputValue.trim(),
      });

      // assuming it always returns an array
      if (deleteTripResponse[0]["Results"] === 0) {
        this.$showAlert(
          "success",
          "Trip Deleted",
          `${this.selectedWhiteContainer["ConsignmentNo"]} Trip (${this.selectedWhiteContainer["MovementType"]}) successfully deleted`,
          [{"text": "OK"}]
        );
        this.refreshPendingTrips();
      } else {
        this.$showAlert(
          "error",
          "Error Deleting Trip",
          deleteTripResponse[0]["ErrMsg"] || `An error occurred while deleting ${this.selectedWhiteContainer["ConsignmentNo"]} Trip (${this.selectedWhiteContainer["MovementType"]})`,
          [{"text": "OK"}]
        );
      }
      this.$fullscreenLoading();
      this.showDeleteTripPopup = false;
    },
    rightMenuCloseClicked : async function () {
      if (
        this.statusTaskUpdateShow && // HMSUpdateStatusTask component shown
        !this.assignShow && // AssignV3 component not shown
        !this.pendingTripShow && // pending trips not shown (the screen right before HMSUpdateStatusTask)
        !(await this.radioCallDiscardAttachments()) // user does not want to discard newly uploaded attachments
      ) {
        return; // don't close right menu
      }

      this.radioCallAttachmentsChanged = false;
      this.pendingTripShow = false; 
      this.rightMenuShow = false; 
      this.selectedPendingTrip = []; 
      this.assignShow = false; 
      this.assignSelected = null; 
      this.selectedIndex = -1; 
      this.selectedWhiteContainer = null;
      this.consignmentDetailShow = false;
      this.selectedDriver = null;
    },

  //#region Radio Call
    whiteContainerClicked : function (event, index, fullData) {
      if (index == this.selectedIndex || event.target.tagName === 'IMG') {
      // if (index == this.selectedIndex) {
        this.selectedIndex = -1;
        this.selectedWhiteContainer = null;
        return;
      }
      this.selectedIndex = index;
      this.selectedWhiteContainer = fullData;
    },

    consignmentInfoClicked : function (event, fullData) {
      this.consignmentDetailShow = true;
      this.receivedData = fullData;
    },

    radioCallButtonClicked : function (e) {
      this.rightMenuShow = true;
      this.pendingTripShow = false;
      this.statusTaskUpdateShow = true;
    },
    
    //#endregion


    //#region Horizontal Resizer
    horizontalResizerMousedown: function(e) {
      this.horizontalResizing = true;
      this.topHeight = e.clientY - 65;
      document.addEventListener('mousemove', this.horizontalDragging);
      document.addEventListener('mouseup', this.horizontalResizerMouseup);
    },
    horizontalResizerMouseup: function(e) {
      this.horizontalResizing = false;
      document.removeEventListener('mousemove', this.horizontalDragging);
      document.removeEventListener('mouseup', this.horizontalResizerMouseup);

      let height = e.clientY - 65;
      this.horizontalDragBoundaries(height);
    },
    horizontalDragging: function(e) {
      let height = e.clientY - 65;
      this.horizontalDragBoundaries(height);
    },
    horizontalDragBoundaries: function(height) {
      if (height < 75) {
        this.topHeight = 75;
        return;
      } else {
        this.topHeight = height;
      }

      if (height > window.innerHeight - 155) {
        this.topHeight = window.innerHeight - 155;
        return;
      } else {
        this.topHeight = height;
      }
    },
    //#endregion

    //#region Vertical Resizer
    verticalResizerMousedown: function(e) {
      this.mapResizing = true;
      this.topMenuWidth = this.$refs['topMenu']['$el'].getBoundingClientRect().width + 55;
      this.mapWidth = e.clientX - this.topMenuWidth;
      document.addEventListener('mousemove', this.verticalDragging);
      document.addEventListener('mouseup', this.verticalResizerMouseup);
    },
    verticalResizerMouseup: function(e) {
      this.mapResizing = false;
      document.removeEventListener('mousemove', this.verticalDragging);
      document.removeEventListener('mouseup', this.verticalResizerMouseup);

      let width = e.clientX - this.topMenuWidth;
      this.verticalDragBoundaries(width);
    },
    verticalDragging: function(e) {
      let width = e.clientX - this.topMenuWidth;
      this.verticalDragBoundaries(width);
    },
    verticalDragBoundaries: function(width) {
      const boundWidthMax = window.innerWidth - 493;
      const boundWidthMin = window.innerWidth - 1067;

      if (width > boundWidthMax ) {
        this.mapWidth = boundWidthMax;
      } else if (width < boundWidthMin) {
        this.mapWidth = boundWidthMin;
      } else {
        this.mapWidth = width;
      }
    },
    //#endregion

    //#region Menus functions
    bottomMenuClicked: async function(item) {
      let index = this.bottomMenus.indexOf(item);
      let menuItem = this.bottomMenus[index];
      menuItem['show'] = !menuItem['show'];
      menuItem['icon'] = `https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/${menuItem['title'] ? `${menuItem['title'].replace(/ /g, '').replace(/\-/g, '')}_${menuItem['show'] ? 'green' : 'gray'}` : ''}.png`;

      if (menuItem['show']) {
        if (!this.openMenuTitles.includes(menuItem['title'])) {
          this.openMenuTitles.push(menuItem['title']);
        }
        
        menuItem['loading'] = true;
        menuItem['tableData'] = this.$deepTrimJsonV3(await this.$apiCallV2(`/VehicleTracker/GetHMSJobListing?bucket=${menuItem['title']}`));
        menuItem['tableData'] = menuItem['tableData'].filter(item => item['CNLastUpStatus'] != '8505') 
        menuItem['loading'] = false;
      } else {
        this.openMenuTitles = this.openMenuTitles.filter(t => t !== menuItem['title']);
        menuItem['tableData'] = [];
      }
    },
    tripAssigned: async function (result){      
      // Store the open menu titles BEFORE calling getBottomMenus
      const currentOpenTitles = [...this.openMenuTitles];
      
      if (result) {
        this.rightMenuShow = false;
        this.assignShow = false;
        this.assignSelected = null;
      }
      // Await the getBottomMenus to ensure bottomMenus is rebuilt
      await this.getBottomMenus();
      
      if (currentOpenTitles.length > 0 && result) {
        for (const title of currentOpenTitles) {
          let menuToOpen = this.bottomMenus.find(menu => menu.title === title);
          
          if (menuToOpen && !menuToOpen.show) {
            menuToOpen.show = true;
            menuToOpen.icon = `https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/${menuToOpen.title ? `${menuToOpen.title.replace(/ /g, '').replace(/\-/g, '')}_green` : ''}.png`;
            
            menuToOpen.loading = true;
            menuToOpen.tableData = this.$deepTrimJsonV3(await this.$apiCallV2(`/VehicleTracker/GetHMSJobListing?bucket=${menuToOpen.title}`));
            menuToOpen.tableData = menuToOpen.tableData.filter(item => item['CNLastUpStatus'] != '8505');
            menuToOpen.loading = false;
          }
        }
      }
    },
    topMenuClicked: async function(item) {
      switch (item['title']) {
        case 'Show RFC Containers':
          if (!this.showRFCContainer) {
            this.showRFCContainer = true;
						this.selectedMarker = null;
            this.getRfcContainers();
          } else {
            this.showRFCContainer = false;
            this.totalMarkersOnMap.forEach(marker => {
              if (marker['type'] == 'rfc') {
                marker['marker'].setMap(null);
              }
            });
						this.rfcMarkers = [];
						this.$refs['vehicleMap'].fitBounds();
          }
          this.topMenus[0]['icon'] = `https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RFC_${this.showRFCContainer ? 'green' : 'gray'}.png`
          break;
        case 'Refresh':
          this.refreshClicked(item);
          break;
        case 'Refresh Interval':
          this.showInterval = !this.showInterval;
          break;
        case 'Legend':
          this.showLegend = !this.showLegend;
          break;
      }
    },
    //#endregion

    //#region API Calls
    getBottomMenus: async function() {
			// Get API data based on the menu buttons chosen (eg. delivery, pending collection etc.)
      let menus = await this.$apiCallV2(`/VehicleTracker/GetListMaster?master=HMS_RC_JOBBUCKETS`);
      this.bottomMenus = [];
      menus.forEach((m) => {
        this.bottomMenus.push({
          'title': !m['Description'] ? '' : m['Description'],
          'icon': 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/' + (!m['Description'] ? '' : (m['Description'].replace(/ /g, '').replace(/\-/g, '') + '_gray')) + '.png',
          'show': false,
          'loading': false,
          'tableData': [],
        });
      });
    },
    refreshClicked: async function(e) {
      this.vehicleList = [];
      this.vehicleLoading = true;

			// data for top right table box
      let vehicles = this.$deepTrimJsonV3(await this.$apiCallV2(`/VehicleTracker/GPS_GetLastLocationVehicleByCategory`));
      vehicles = this.$jsonNullToStringV2(vehicles);
      vehicles = this.$deepTrimJsonV3(vehicles);
		
      this.vehicleList = vehicles.map(ll => {
        return {
          'Status': (ll['Trip Status'] == 'In Collection') ? 'In Col' : (ll['Trip Status'] == 'In Delivery') ? 'In Del' : '',
          'Vehicle': (ll['lorry_no'] + ' (' + (!ll['vehiclecode'] ? '' : ll['vehiclecode']) + ')'),
          'GPS Log Time': ll['GPSLogTime'],
          'Last Job Update Time' :  ll['DateTimeLog'],
          'No Job Since' : this.formatMinutesToHoursMin(ll['MinutesLagFrLastUpdate']),
          'GPS Current Location': (!ll['GPSLocName'] ? '' : ll['GPSLocName']) + (' (' + (!ll['GPSLatitude'] ? '' : ll['GPSLatitude']) + ',' + (!ll['GPSLongitude'] ? '' : ll['GPSLongitude']) + ')'),
          'Driver': !ll['Drivername'] ? '' : (ll['Drivername'] + ' (' + (!ll['DriverCode'] ? '' : ll['DriverCode']) + ')' + 
          ( (!ll['Staff_Status']) ? '' : 
          ( (ll['Staff_Status'] == 'O')
            ? '\t<img src="https://img.icons8.com/fluency-systems-regular/16/fa314a/attendance-mark--v19.png"/>' 
            : '\t<img src="https://img.icons8.com/fluency-systems-regular/16/26e07f/attendance-mark--v19.png"/>'))),
          'Pending Trips': !ll['PendingTrips'] ? '0' : ll['PendingTrips'],
          'Consignment #': ll['ConsignmentNo'],
          'ETA': ll['ETA'],
          'From': (!ll['DepCompany'] ? '' : ll['DepCompany']) + ((!ll['DepLat'] || !ll['DepLon']) ? '' : (' (' + (!ll['DepLat'] ? '0' : ll['DepLat']) + ',' + (!ll['DepLon'] ? '0' : ll['DepLon']) + ')')),
          'To': (!ll['DestCompany'] ? '' : ll['DestCompany']) + ((!ll['DestLat'] || !ll['DestLon']) ? '' : (' (' + (!ll['DestLat'] ? '0' : ll['DestLat']) + ',' + (!ll['DestLon'] ? '0' : ll['DestLon']) + ')')),
          'Position' : { 'lat' : parseFloat(ll['GPSLatitude']), 'lng' : parseFloat(ll['GPSLongitude'])},
          'Staff_Status' : (ll['Staff_Status'] == '') ? '' : (ll['Staff_Status'] == 'I') ,
          'fullData': ll,
          'DepartureCompanyCode' : `${ll['DepCompany']} ${(ll['DepartureCode'] == '') ? '' : `(${ll['DepartureCode']})`} `,
          'DestinationCompanyCode' : `${ll['DestCompany']} ${(ll['DestinationCode'] == '') ? '' : `(${ll['DestinationCode']})`} `,
        }
      })
      
      this.vehicleLoading = false;

			// create vehicle markers
      this.addVehicleMarkers(this.vehicleList);

      if (e) {
        this.startInterval();
      }
    },
    //#endregion

    //#region Add Marker methods
    addVehicleMarkers : function (data) {
			
			if (this.infoWindowOpened) {
        this.infoWindowOpened.close();
      }
      this.vehicleMarkers = [];
      this.selectedMarker = null;
      data.forEach(v=> {
				let lat = v['Position'].lat;
				let long = v['Position'].lng;
				if (!isNaN(lat) && !isNaN(long)) {
					let marker = new google.maps.Marker({
						position: v['Position'],
						icon : {
							url: `https://dsmapi.logistics.systems/dsm6gicons/Truck${v['Staff_Status'] ? 'On' : 'Off'}.png`,
							scaledSize: new google.maps.Size(40, 40)
						},
						// label : {
						// 	text : v['Vehicle'],
						// 	className : 'marker-label',
						// },
						map: this.myMap
					});
					marker['type'] = 'vehicle';

          setTimeout(() => {
            this.$refs['vehicleMap'].addCustomMarker(marker);
          }, 300);
          
      
       
					let tempMarker = {
						type : 'vehicle',
						marker : marker
					}
					this.vehicleMarkers.push(tempMarker);
				}
      })			
      this.$refs['vehicleMap'].fitBounds();
    },
    addRFCMarkers : function (data) {
      if (this.infoWindowOpened) {
        this.infoWindowOpened.close();
      }
      this.rfcMarkers = [];
			this.identicalLatLng = [];
      this.selectedMarker = null;
      data.forEach(r => {
        let lat = r['Position']['lat'];
        let long = r['Position']['lng'];
        if (!isNaN(lat) && !isNaN(long)){
          let marker = new google.maps.Marker({
            position : r['Position'],
            icon : {
              url : `https://dsmapi.logistics.systems/dsm6gicons/Warehouse.png`,
              scaledSize : new google.maps.Size(40, 40)
            },
            map : this.myMap
          })
					marker['type'] = 'rfc';
          let tempMarker = {
            type : 'rfc',
            marker : marker
          }
          setTimeout(() => {
            this.$refs['vehicleMap'].addCustomMarker(marker); // timeout for zoom-out animation
          }, 300);
          this.rfcMarkers.push(tempMarker);
        }
      })
      this.$refs['vehicleMap'].fitBounds();
    },
    //#endregion
		
		getRfcContainers : async function () {
			this.$fullscreenLoading('Getting RFC Containers')
			let rfcContainers =  await this.$apiCallV2(`/VehicleTracker/GetHMSRadiocallCollection`);
			rfcContainers = this.$jsonNullToStringV2(rfcContainers);
			rfcContainers = this.$deepTrimJsonV3(rfcContainers);
			rfcContainers.forEach(data => {
				data['CNContNo'] = `${data['ConsignmentNo']} / ${data['ContainerNo']}`
				data['SzTypHdgDel'] = `${data['ContSize']}${data['ContType']} / ${data['HandlingType']} / ${data['DeliveryType']}`
				data['Company'] = `${data['company']} ${data['AreaName'] == '' ? '' : `(${data['AreaName']})`}`
				data['Delivery Time'] = `${data['DelDate']}`
				data['ETA'] = data['Date_ETA']
				data['Advice For RFC'] = this.formatDateAndTime(data['RecRFCDate'], data['RecRFCTime'])
				data['To Collect'] = `${data['RFCDate']} ${data['RFCRemarks'] == '' ? '' : `[${data['RFCRemarks']}]`}`
				data['Drop Off'] = data['DropOff']
				data['Position'] = {lat : parseFloat(data['Latitude']), lng : parseFloat(data['Longtitude'])}
			})
			this.rfcContainersData = rfcContainers;
			this.addRFCMarkers(this.rfcContainersData);

			this.$fullscreenLoading('')
		},
    //#region Vehicle List functions
    vehicleButtonClicked: async function(text, data) {
      if (text.includes('https://dsmapi.logistics.systems/dsm6gicons/icons8-location-64.png')) { // Location button is clicked
        let lat = data['fullData']['GPSLatitude'];
        let lng = data['fullData']['GPSLongitude'];

        if (lat && lng) {
          let pos = { lat: parseFloat(lat), lng: parseFloat(lng) };
          let marker = this.vehicleMarkers.find(m => {
            let mPos = { lat: m['marker'].position.lat(), lng: m['marker'].position.lng() };
            return JSON.stringify(pos) == JSON.stringify(mPos);
          }); // find the clicked marker in the vehicleMarkers created.

          if (marker['marker']) {
						let pos = { lat: marker['marker'].position.lat(), lng: marker['marker'].position.lng() };
						this.myMap.setCenter(pos);
						this.myMap.setZoom(17);
            this.markerClicked(marker['marker'], pos, data);
          }
        }
      } else { // In Show pending trip button is clicked
			
        this.assignShow = false;
        this.selectedIndex = -1;
        this.selectedWhiteContainer = null;
        this.statusTaskUpdateShow = false;

				this.rightMenuShow = true;
				this.pendingTripShow = true;
     
        this.pendingTripHeaderFooterBg = data['Staff_Status'];
        this.selectedDriver = data;
        this.refreshPendingTrips();
      }
    },
    refreshPendingTrips : async function () {

      this.selectedPendingTrip = [];
      const driver = this.selectedDriver['fullData']['DriverCode'];
      this.$fullscreenLoading(`Getting Trips of Driver ${driver}`)
      try {
        let pendingTripData = await this.$apiCallV2(`/VehicleTracker/GetHMSTripsByDriver?driver=${driver}`);
        if (Array.isArray(pendingTripData) && pendingTripData.length != 0) {
           pendingTripData = this.$jsonNullToStringV2(pendingTripData);
            pendingTripData = this.$deepTrimJsonV3(pendingTripData);
            let ptArr = [];
            pendingTripData.forEach(i => {
              ptArr.push({
                "Vehicle" : this.selectedDriver['Vehicle'],
                "Driver" : this.selectedDriver['Driver'],
                "IsClockedIn" : this.selectedDriver['Staff_Status'],
                "Container #" : i['ContainerNo'],
                "Consignment #" : i['ConsignmentNo'],
                "BillToName" : i['BillToName'],
                "SzTy" : `${i['ContSize']}${i['ContType']}`,
                "MovementType" : `${i['MovementType']}`,
                "FromToArea" : `[${i['FromDestCode']} (${i['FromArea']}) - ${i['ToDestCode']} (${i['ToArea']})]`,
                "FullData" : i,
                "B2BContainer #" : i['B2BContainerNo'],
                "B2BSzTy" : `${i['B2BContSize']}${i['B2BContType']}`
              })
            })
            this.selectedPendingTrip = ptArr;
        } else {
          this.selectedPendingTrip = [];
        }
        
      } catch (error) {
        console.error('Error retrieving driver\'s Trip');
        this.selectedPendingTrip = [];
      }
      this.$fullscreenLoading();


    },
    markerClicked : async function (marker, pos, vehicle) {
			
			this.selectedMarker = marker;
			this.dataToPreview = [];
			this.dataToPreviewIndex = 0;

			let differentiate = this.selectedMarker['type'];
     
      let pointedMarker; // assigned a value below
			let currentLat = pos.lat;
			let currentLong = pos.lng;

			if (differentiate == 'rfc') {
				
				let allRfcMarkers = this.totalMarkersOnMap.filter(i => {
					return i['type'] == 'rfc'
				});

				this.identicalLatLng = allRfcMarkers.filter(i => {
					let tempLat = i['marker']['position'].lat();
					let tempLong = i['marker']['position'].lng();
					return tempLat==currentLat && tempLong == currentLong
				})
	
				this.dataToPreview = this.rfcContainersData.filter(i => {
					let tempLat = this.identicalLatLng[0]['marker']['position'].lat()
					let tempLng = this.identicalLatLng[0]['marker']['position'].lng()
					return i['Latitude'] !== '' && i['Latitude'] == tempLat && i['Longtitude'] !== '' &&i['Longtitude'] == tempLng
				})

				if (this.identicalLatLng.length != this.dataToPreview.length) {
					return;
				}

        this.dataToPreview = this.dataToPreview.map((data) => { data["_markerType"] = "rfc"; return data; });
        // tag data with a marker type, checked in window.previousPage() and window.nextPage()
        pointedMarker = this.dataToPreview[0];

			} else if (differentiate == 'vehicle'){
				let allVehicleMarkers = this.totalMarkersOnMap.filter(i => {
					return i['type'] == 'vehicle'
				});

				this.identicalLatLng = allVehicleMarkers.filter(i => {
					let tempLat = i['marker']['position'].lat();
					let tempLong = i['marker']['position'].lng();
					return tempLat==currentLat && tempLong == currentLong
				});

				this.dataToPreview = this.vehicleList.filter(i => {
					let tempLat = this.identicalLatLng[0]['marker']['position'].lat()
					let tempLng = this.identicalLatLng[0]['marker']['position'].lng()
					return i['Position']['lat'] !== '' && i['Position']['lat'] == tempLat && i['Position']['lng'] !== '' && i['Position']['lng'] == tempLng
				})

        this.dataToPreview = this.dataToPreview.map((data) => { data["_markerType"] = "vehicle"; return data; });
        // tag data with a marker type, checked in window.previousPage() and window.nextPage()

        if (this.identicalLatLng.length > 1 && vehicle) {
          // if the locate vehicle button is clicked, vehicle won't be null
          // if the marker on the map is clicked, vehicle will be null. in this case, just display the first vehicle with the specified coordinates
          this.dataToPreviewIndex = this.dataToPreview.findIndex((v) => { return vehicle["Vehicle"] == v["Vehicle"]; });
          pointedMarker = this.dataToPreview[this.dataToPreviewIndex];
        } else {
          pointedMarker = this.dataToPreview[0];
        }
			} else {
				return;
			}
      
      if (this.infoWindowOpened) {
        this.infoWindowOpened.close(); // close to refresh new outerhtml rendering
      }

      let outerhtml = await this.formatDataToOuterHTML(pointedMarker, differentiate);
      this.infoWindowOpened = marker.setInfoWindow(outerhtml, this.myMap, { x: 0, y: -20 });
    }, 
    intervalClicked: function(time) {
      this.currentInterval = time;
      this.showInterval = false;

      this.startInterval();
    },
    startInterval: function() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }

      this.refreshInterval = setInterval(() => {
        this.refreshClicked();
      }, this.currentInterval);
    },
    //#endregion

    //#region Bottom functions
    bottomTableButtonClicked: function(text, data, title) {
      this.rightMenuShow = true;
			this.pendingTripShow = false;
      this.statusTaskUpdateShow = false;
      this.assignShow = true;
      data['Type'] = 'Manual'
			data['Bucket'] = title;
      this.assignSelected = data;
      this.assignTitle = title;
    },
    //#endregion

		//#region Formatter
    formatDateAndTime : function (date, time){
      if (date !== '' && time !== '') {
        let front = date.split(' ')[0];
        let splittedBack = time.split('');
        let back = `${splittedBack[0]}${splittedBack[1]}:${splittedBack[2]}${splittedBack[3]}`
        return `${front} ${back}`;
      } else {
        return ''
      }
    },
    formatMinutesToHoursMin: function(totalMinutes) {
      let result = ''
      if (totalMinutes == '') {
        
        return result;
      }
      result = `${totalMinutes} min`

      if (parseInt(totalMinutes) > 60) {
        let hours = Math.floor(totalMinutes / 60);
        let minutes = totalMinutes % 60;
        result = `${hours} hr ${minutes} min`;
      }
      return result ;
    },
    formatDataToOuterHTML : function (data, type) {

      if (type == 'vehicle') {
        return this.createInfoWindowForVehicle(data);
      } else if (type == 'rfc') {
        return this.createInfoWindowForRFCContainers(data);
      } else {
        return;
      }

    },
		//#endregion

		//#region Create Info Window
    createInfoWindowForVehicle : async function (data) {
			// data to preview on info window
			this.infoWindowArr = [
				{title : 'Vehicle', value : data['Vehicle']},
				{title : 'Driver', value : data['Driver']},
				{title : 'Consignment #', value : data['Consignment #']},
				{title : 'From', value : data['DepartureCompanyCode']},
				{title : 'To', value : data['DestinationCompanyCode']},
				{title : 'Last Job Update', value : data['Last Job Update Time']},
				{title : 'No Job Since', value : data['No Job Since']}
			]

			let resolve = null;
			
			let outer = '';
			this.$nextTick(() => {
				let mainDiv = document.querySelectorAll('.mainDiv')[0];
				mainDiv.querySelectorAll('.button-left-container')[0].style.setProperty('visibility', 'hidden');
				outer = mainDiv.outerHTML;
				outer = outer.replace('style="display: none;"', '');
				mainDiv.querySelectorAll('.button-left-container')[0].style.setProperty('visibility', 'visible');
				resolve();
			})
			
			await new Promise(res => resolve = res);
			
			this.assignCollectionData = JSON.parse(JSON.stringify(data));
			return outer;
    },
    createInfoWindowForRFCContainers : async function (data) {
			this.infoWindowArr =  [
				{title : 'Cn / Cont . No', value : data['CNContNo']},
				{title : 'SzTyp/ Hdg / Del', value : data['SzTypHdgDel']},
				{title : 'Company', value : data['Company']},
				{title : 'Delivery Time', value : data['Delivery Time']},
				{title : 'ETA', value :  data['ETA']},
				{title : 'Advice For RFC', value : data['Advice For RFC']},
				{title : 'To Collect', value : data['To Collect']},
				{title : 'Drop Off', value : data['Drop Off']},
			];

			let resolve = null;
			
			let outer = '';
			this.$nextTick(() => {
				let mainDiv = document.querySelectorAll('.mainDiv')[0];
				Array.from(mainDiv.querySelectorAll('.infoRow')).at(-2).childNodes.forEach(i => {
					i.style.setProperty('color', 'red')
				})
				outer = mainDiv.outerHTML;
				outer = outer.replace('style="display: none;"', '');
				Array.from(mainDiv.querySelectorAll('.infoRow')).at(-2).childNodes.forEach(i => {
					i.style.setProperty('color', 'black')
				})
				resolve();
			})
			
			await new Promise(res => resolve = res);
			this.assignCollectionData = JSON.parse(JSON.stringify(data));
			return outer;
    },
		//#endregion
  },
  mounted() {
   
    this.$bus.$on('infoWindowClose', () => {
			// when InfoWindow close button is clicked, infoWindowClose event emitted from main.js
			if (this.infoWindowOpened) { 
				// if info window is opened, clear info window, clear selected marker, reset all opacity of markers 
				this.infoWindowOpened = null;
				this.selectedMarker = null;
				this.$nextTick(() => {
					this.totalMarkersOnMap.forEach(m => m['marker'].setOpacity(1));
				})
			}
    })

		//#region Info Window functions

		// Assign Collection button for RFC marker
    window.assignCollection = () => {
			if (this.pendingTripShow) {
				this.pendingTripShow = false;
			}
      this.pendingTripShow = false;
      this.statusTaskUpdateShow = false;
			this.rightMenuShow = true;
      this.assignShow = true;
      this.assignTitle = 'Collection'
      let cnctn = this.assignCollectionData['CNContNo'].split(' / ');
			// data to be populated in AssignV3 
      let tempObj = {
        'Consignment #' : cnctn[0],
        'Container #' : cnctn[1],
        'Sz/Ty' : `${this.assignCollectionData['ContSize']}${this.assignCollectionData['ContType']}`,
        'Hdg' : this.assignCollectionData['HandlingType'],
        'Del' : this.assignCollectionData['DeliveryType'],
        'Type' : 'rfc',
				'Bucket' : 'Collection',
				'Remarks' : this.assignCollectionData['Remarks'],
				'FullData' : this.assignCollectionData
      }
      this.assignSelected = tempObj;
    }
		window.previousPage = async () => {
			// if only one data in the location
			if (this.dataToPreview.length === 1) {
				return;
			}
			// close info window before swapping to next location's data
			this.infoWindowOpened.close();
			
      this.dataToPreviewIndex--;
			if (this.dataToPreviewIndex < 0) {
				this.dataToPreviewIndex = this.dataToPreview.length - 1; // reset to the last data when pressing prev on first data
			}
			let outerhtml = '';
      switch (this.dataToPreview[this.dataToPreviewIndex]["_markerType"]) {
        case "vehicle": // if selected marker is vehicle type
          outerhtml = await this.createInfoWindowForVehicle(this.dataToPreview[this.dataToPreviewIndex]);
          break;

        case "rfc": // if selected marker is rfc type
          outerhtml = await this.createInfoWindowForRFCContainers(this.dataToPreview[this.dataToPreviewIndex]);
          break;

        default:
          if (process.env['NODE_ENV'] == 'development') {
            console.error("_markerType not set in markerClicked method or not checked for in window.previousPage");
            // you need to tag each dataToPreview with a _markerType in the markerClicked method
            // and then check for it here
            // or else the previous and next buttons on the info window won't work
          }
          break;
      }
			// offset infowindow - prevent label from blocking - delete the third parameter to restore default (no offset)
			this.selectedMarker.setInfoWindow(outerhtml, this.myMap, { x: 0, y: -20 });
		}
		window.nextPage = async () => {
			// if there's only one data in the location
			if (this.dataToPreview.length === 1) {
				return;
			}
			// close the info window before render the next data
			this.infoWindowOpened.close();

			this.dataToPreviewIndex++;
			if (this.dataToPreviewIndex >= this.dataToPreview.length) {
				this.dataToPreviewIndex = 0; // reset to 0 when exceeds the length of data to be shown
			}
			let outerhtml = '';
			switch (this.dataToPreview[this.dataToPreviewIndex]["_markerType"]) {
        case "vehicle": // if selected marker is vehicle type
          outerhtml = await this.createInfoWindowForVehicle(this.dataToPreview[this.dataToPreviewIndex]);
          break;

        case "rfc": // if selected marker is rfc type
          outerhtml = await this.createInfoWindowForRFCContainers(this.dataToPreview[this.dataToPreviewIndex]);
          break;

        default:
          if (process.env['NODE_ENV'] == 'development') {
            console.error("_markerType not set in markerClicked method or not checked for in window.nextPage");
            // you need to tag each dataToPreview with a _markerType in the markerClicked method
            // and then check for it here
            // or else the previous and next buttons on the info window won't work
          }
          break;
      }
			this.selectedMarker.setInfoWindow(outerhtml, this.myMap, { x: 0, y: -20 });
		}

		//#endregion

    this.getBottomMenus();
    this.refreshClicked();
    
    this.startInterval();

  },
  watch: {
    selectedMarker : function (val) {
			if (val) {
				this.totalMarkersOnMap.forEach(m => m['marker'].setOpacity(0.25)); // set all markers to blur
				this.totalMarkersOnMap.forEach(m => m['marker'].setZIndex(1)); // set index to highest/
      	this.$nextTick(() => {
          val.setOpacity(1);
          val.setZIndex(2);
        }); // set the selected marker to not blur

				if (this.infoWindowOpened) {
					this.infoWindowOpened.close(); // close to refresh new outerhtml rendering
				}
			}
    },
		totalMarkersOnMap : function (val) {
			if (this.markerCluster) {
				this.markerCluster.clearMarkers();
			}
			this.markerCluster = new markerClusterer.MarkerClusterer({ map: this.myMap, markers: val.map(v => v['marker']) });
			
			this.$refs['vehicleMap'].fitBounds();
		},
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.vehicle-tracking-main {
  display: flex;
  height: 100%;
  width: 100%;
  font-size: 12px;
  padding: 10px 5px 10px 45px;

  > .main-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    height: 100%;
    position: relative;
    transition: 0.3s;
    margin-right: 5px;

    > .top-section, > .bottom-section {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      overflow: hidden;

      > .menu-section {
        height: 100%;
        overflow: auto;
        min-width: fit-content;
      }

      > .section-content {
        display: flex;
        width: 100%;
        height: 100%;
        margin-left: 5px;
        position: relative;
        overflow: hidden;

        > .content {
          background-color: white;
          width: 100%;
          height: 100%;
          padding: 5px;
          border-radius: 5px;
          position: relative;
          overflow: hidden;

          &:not(:nth-child(1)) {
            margin-left: 13px;
          }

          > .table-section {
            overflow: hidden;
          }

          > .additional-content {
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 10px;
            z-index: 99;

            > .content-items {
              padding: 5px;
              background-color: white;
              border-radius: 5px;
              box-shadow: 0 0 5px 0 gray;
              margin-top: 5px;
              font-size: 10px;
              display: flex;
              flex-direction: column;

              > .legend-item {
                display: flex;
                align-items: center;

                > img {
                  height: 25px;
                  width: 25px;
                }

                > div {
                  margin-left: 5px;
                  white-space: nowrap;
                }
              }
              
              > button {
                font-size: 10px;
                padding: 3px;
                // width: fit-content;
                width: 100%;
                margin-top: 3px;
              }
            }
          }
        }
      }
    }

    > .bottom-section {
      margin-top: 13px;

      > .job-listing-section {
        display: flex;
        overflow: auto;
        height: 100%;
        width: 100%;
        margin-left: 5px;

        > .empty {
          width: 100%;
          margin-left: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: lightgray;

          > .empty-content {
            text-align: center;
            background-color: white;
            height: 100px;
            width: 150px;
            border: 1px solid ;
            border-radius: 5px;
            box-shadow: 2px 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            white-space: normal
          }
        }

        > div {
          height: 100%;
          min-width: 400px;
          background-color: white;
          padding: 5px;
          border-radius: 5px;
          position: relative;

          &:not(:first-child) {
            margin-left: 5px;
          }

          > .loader {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 21;
            background-color: rgba(0,0,0,0.2);
            display: flex;
            align-items: center;
            justify-content: center;

            > .content {
              background-color: white;
              padding: 5px;
              border-radius: 5px;
              text-align: center;
            }
          }
        }
      }
    }
  }

  > .delete-trip-popup {

    .prompt {
      margin-bottom: 5px;
    }

    .trip-details {
      margin: 5px 44px 5px 44px;

      .detail-name {
        width: 40%;
        text-align: left;
      }

      .detail-colon {
        width: 5%;
      }

      .detail-value {
        text-align: left;
      }
    }

    .reason {
      margin: 5px 44px 5px 44px;
      width: calc(100% - 44px - 44px); // 100% minus left and right margins
    }
  }
}

.resizer {
  background-color: transparent;
  position: absolute;
  // background-color: rgba(0,255,255,0.3);

  &:active {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    // background-color: red;
    opacity: 0.1;
    height: 100vh;
    width: 100vw;
  }
}

.resize-bar {
  background-color: black;
  position: absolute;
  z-index: -1;
}

$assignBg: rgb(235, 235, 255);
$assignSection : #535cda;
$brParent : 10px;
$brChild : 5px;

.pending-trip-main {
  background-color: $assignBg;
  width: 100%;
  height: calc(100% - 10px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > * {
    padding: 5px;
    border-radius : $brChild;
  }

  > .pending-trip-header {
    height: 30px;
    width: 100%;
    background-color: $assignSection;
    color: white;
    font-weight: 700;
    position : relative;

    > span {
      width: calc(100% - 28px);
      height: 100%;
      font-weight: bold;
    }

    > img { 
      width: 100%;
      right: 5px;
      top : 5px;
      /* margin-right: 5px; */
      position : absolute;
    }
  }

  > .pending-trip-content {
    width: 100%;
    height: calc(100% - 40px);
    overflow: hidden;
    margin: 5px 0px;

    > .label-container {
      width: 100%;
      height: fit-content;

      > .label-row {
        height: fit-content;
        width: 100%;
        display : flex;
        justify-content: space-between;
        margin-bottom: 5px;

        > .label-title {
          font-weight: 700;
        }
      }
    }

    > .content-container {
      width: 100%;
      height: calc(100% - 40px);
      overflow: auto;
      position: relative;
      > .white-container {
        width: 100%;
        height: fit-content;
        background-color: white;
        margin-bottom: 5px;
        padding: 5px;
        border: 1px solid black;
        cursor: pointer;
        position: relative;

        > .white-container-right {
          width: 20px;
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          flex-direction: column;
          align-items: center;

          > .white-container-right-lower {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            margin-bottom: 5px;
          }
        }
        
        &:hover {
          background-color: #a6acff;
          color : white;
        }

        > .white-container-left {
          width: calc(100% - 20px);
          height: 100%;
          > .pt-row {
          display: flex;
          justify-content: space-between;
  
          > .pt-title {
            text-align: left;
            font-weight: bold;
          }
  
          > .pt-value {
            text-align: right;
          }
        }

        }
      }

      > .consignment-details {
        overflow: auto;
        width: 100%;
        height: calc(100% - 20px);
        padding: 5px;
        display: flex;
        flex-direction: column;
        background-color: white;
        top: 0;
        left: 0;
        border: 1px solid black;

        > .consignment-detail-close {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          position: sticky;
          top : 0;

        }
        > .tab-row {
          width: 100%;
          height: fit-content;
          display: flex;
          margin-bottom: 5px;

          :nth-child(1) {
            font-weight: bold;
            min-width: 105px;
          }

          :not(:first-child) {
            width: 100%;
          }
          
        }
      }
    }
  }
  
  > .pending-trip-footer {
    width: 100%;
    min-height: 40px;
    max-height: 40px;
    background-color: $assignSection;
    display: flex;
    justify-content : flex-end;

    > .pending-trip-footer-button {
      margin: 0 0 0 5px;
      max-height: 45px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > .more-actions {
      height: 100%;
      width: fit-content;
      margin: 0 0 0 5px;
      position: relative;

      > button {
        height: 100%;
        width: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
          height: 20px;
          width: 20px;

          > img {
            height: 15px;
            width: 15px;
          }
        }
      }

      > .actions-menu {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: calc(100% + 5px);
        right: 0;
        border: 1px solid black;
        border-radius: 3px;

        > button {
          white-space: nowrap;

          &:disabled {
            opacity: 0.7
          }
        }

        :nth-last-child(1) {
          margin-top: 2px;
        }
      }
    }
  }
}

.status-task-update-main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > * {
    padding: 5px;
  }

  > .status-task-update-header {
    background-color: #535cda;
    width: 100%;
    height: 30px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > :nth-child(1) {
      width: 20px;
      height: 100%;
      cursor: pointer;
      user-select: none;
    }
    > :nth-child(2) {
      width: 100%;
      height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
    }

    > img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    
  }

  > .status-task-update-body {
    width: 100%;
    height: calc(100% - 110px);
    background-color: #eaeaea;

  }

  > .status-task-update-footer {
    background-color: #535cda;
    width: 100%;
    max-height: 80px;
    min-height: 80px;
    
    > .message-container {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      padding: 5px;
      overflow: auto;

    }

  }
}

//#region Horizontal Resizer
.hresizer {
  min-height: 13px;
  width: 100%;
  cursor: ns-resize;
}

.hresize-bar {
  height: 3px;
  width: 100%;
}
//#endregion

//#region Vertical Resizer
.vresizer {
  height: 100%;
  min-width: 13px;
  cursor: ew-resize;
}

.vresize-bar {
  width: 3px;
  height: 100%;
}
//#endregion

</style>

<style>

.mainDiv {
  padding: 5px;
	min-width: 200px;
}
.mainDiv .infoMain .infoRow {
  display : flex;
}
.mainDiv .infoMain {
  padding: 5px;
}
.mainDiv .infoMain .button-container {
	display: flex;
	width: 100%;
	height : fit-content;
	align-items: center;
	margin-top : 10px;
}
.mainDiv .infoMain .button-container .button-left-container {
	width: 50%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
}
.mainDiv .infoMain .button-container .button-right-container{
	display : flex;
	width : 50%; 
	justify-content : flex-start; 
	align-items : center;
}
.mainDiv .infoMain .button-container .button-right-container .counter{
	margin: 0px 5px;
}
.mainDiv .infoMain .button-container .button-right-container img { 
	width: 20px;
	height: 20px;
	border: 1px solid black;
	border-radius: 5px;
	cursor: pointer;

}
.mainDiv .infoMain .button-container .button-right-container img:hover {
	background-color: gray;
}

</style>